import {
  ExpertsContainer,
  ListExpertsQueryVariables,
} from '@/client/services/api/graphql/gql/graphql';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { graphQLClient } from '@/client/services/api/clients/graphqlClient';
import { listExpertsQuery } from '../api/queries/listExpertsQuery';

export const useListExperts = (
  variables: ListExpertsQueryVariables,
): UseQueryResult<ExpertsContainer> =>
  useQuery({
    queryKey: ['listExperts', variables],
    keepPreviousData: true,
    queryFn: async () => {
      const data = await graphQLClient.request(listExpertsQuery, variables);

      return data.listExperts;
    },
  });
